import styled, { css } from "styled-components";
// import { styled as muiStyled } from "@mui/system";
import { useState, useEffect } from "react";

import {
  Stack,
  TextField,
  // Grid,
  // Box,
  IconButton,
  Autocomplete,
  FormHelperText,
} from "@mui/material";
import Button from "src/components/core/Button";

import { createFilterOptions } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import CropIcon from "@mui/icons-material/Crop";
import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";

import CameraIcon from "src/components/icon/Camera";
import PlayerIcon from "src/components/icon/Player";

import HotspotLayout from "src/components/HotspotImage/HotspotLayout";
import SpottableImage from "src/components/HotspotImage/SpottableImage";

import AddEmbedModal from "./AddEmbedModal";
import ImageCropperModal from "./ImageCropper/ImageCropperModal";

import TextEditor from "./TextEditor";

import font from "src/styles/font";
// import { MAX_CONTENT_PARAGRAPH } from "./CreateBlog";
import { getLocale } from "react-i18nify";
import { formatFromElastic } from "src/common";

import { searchProduct } from "src/api/product";

import { useDialog } from "src/context/DialogContext";

import { motion, AnimatePresence } from "framer-motion";

const S = {};

S.Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  margin-top: 24px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

S.ContentElement = styled(motion.div)`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* margin-top: 24px; */
  /* align-items: center; */
`;

S.MediaUploadBox = styled.div`
  position: relative;
  padding-top: ${(props) => 100 / props.aspectRatio}%;
  background-color: #f3f1f2;
  border-radius: 24px;
`;

S.UploadInnerBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

S.UploadInput = styled.label`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  /* &:not(:last-child) {
    margin-right: 24px;
  } */
`;

S.UploadLabel = styled.span`
  font-size: ${font.size.md};
  font-weight: bold;
  color: #6c6c70;
  margin-top: 16px;
`;

S.UploadHelperText = styled.span`
  text-align: center;
  font-size: ${font.size.sm};
  color: #6c6c70;
  margin-top: 8px;
`;

S.MediaUploaded = styled.div`
  position: relative;
`;

S.ParagraphBreak = styled.span`
  position: relative;
  margin: ${(props) => (props.$elementIndex === 0 ? 32 : 64)}px 0;

  &::before {
    content: "";
    display: block;
    border-bottom: 1px dashed #bcbcc0;
  }
`;

S.Placement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  /* width: 100%; */
  /* margin: 0 24px; */
  /* &:not(:last-child)::after {
    content: "";
    display: block;
    height: 100%;
    width: 1px;
    background-color: #6c6c70;
  } */
`;

S.PlacementHover = styled.div`
  display: flex;
  padding: 16px;
  border-radius: 24px;
  cursor: pointer;

  &:hover {
    border: 2px dashed #e13b30;
  }

  border: 2px solid ${(props) => (props.active ? "#e13b30" : "transparent")};
`;

S.PlacementItem = styled.div`
  background-color: #d9d9d9;
  border-radius: 24px;

  &:not(:last-child) {
    margin-right: 8px;
  }
`;

S.PlacementHelperText = styled.span`
  margin-top: 16px;
  font-size: ${font.size.sm};
`;

S.VideoEmbedContainer = styled.div`
  position: relative;
  padding-top: calc(100% / (16 / 9));
  display: flex;
  margin-bottom: 24px;
`;

S.YoutubeEmbed = styled.iframe`
  position: absolute;
  border: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

S.TikTokEmbed = styled.iframe`
  border: 0;
  width: 100%;
  height: 770px;
  margin-bottom: 24px;
`;

const Placement = ({
  active,
  repeat = 1,
  width,
  height,
  helperText,
  onClick,
}) => {
  return (
    <S.Placement>
      <S.PlacementHover active={active} onClick={onClick}>
        {[...new Array(repeat)].map((_, index) => (
          <S.PlacementItem
            key={index}
            style={{
              width,
              height,
            }}
          />
        ))}
      </S.PlacementHover>
      <S.PlacementHelperText>{helperText}</S.PlacementHelperText>
    </S.Placement>
  );
};

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  margin-right: 8px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const ProductChoiceDetail = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 35% 35% 30%;
  align-items: center;
  padding: 5px 0;
`;

const SpanProductDetail = styled.span`
  color: ${({ nameProd }) => (nameProd ? "#252525" : "#6C6C70")};
  font-size: 1rem;
  font-weight: 400;
  text-align: ${({ center }) => (center ? "center" : "left")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ price }) =>
    price &&
    css`
      color: #e13b30;
      font-size: 1.25rem;
      font-weight: 600;

      align-self: flex-end;
      text-align: right;
      grid-column: 3;
      grid-row: 1 / span 2;
    `}
`;

const convertPrice = (price) =>
  Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
  }).format(price);

const Step2 = ({
  formControl,
  formErrors,
  formData,
  onChange,
  onAppendElement,
  onRemoveElement,
  onReArrangeParagraph,
}) => {
  const [productList, setProductList] = useState([]);

  const { openDialog, closeDialog } = useDialog();
  const [editorLoaded, setEditorLoaded] = useState(false);

  useEffect(() => {
    setEditorLoaded(true);
  }, []);

  useEffect(() => {
    (async () => {
      await searchProduct({}).then(async ({ data }) => {
        setProductList(
          data?.rows.length > 0
            ? data?.rows?.map((product) => ({
                ...formatFromElastic(product),
              }))
            : [],
        );
      });
    })();
  }, []);

  return (
    <S.Container>
      <label style={{ fontSize: font.size.lg }}>เนื้อหาบทความ</label>
      <label style={{ alignSelf: "flex-start", fontSize: font.size.md }}>
        เลือกสินค้าที่มีในเนื้อหา
      </label>
      <Autocomplete
        aria-required={true}
        multiple
        id="combo-box-similars"
        getOptionSelected={(option, value) => option._id === value._id}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={`item-${option._id}`} style={{}}>
            {!!option?.group_image?.product_display_image === false ? (
              <ImageEmpty>
                <InsertPhotoIcon
                  sx={{
                    color: "rgba(0, 0, 0, 0.54)",
                    cursor: "pointer",
                  }}
                />
              </ImageEmpty>
            ) : (
              <img
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "cover",
                  objectPosition: "center",
                  borderRadius: "16px",
                  marginRight: "8px",
                }}
                src={
                  option?.group_image?.product_display_image
                    ? option?.group_image?.product_display_image.replace(
                        ".com",
                        ".com/300x300",
                      )
                    : ""
                }
                alt={option?.group_image?.product_display_image}
              />
            )}
            <ProductChoiceDetail>
              {/* name */}
              <SpanProductDetail nameProd>
                {option?.product?.item_name
                  ? option?.product?.item_name
                  : "ไม่มีชื่อ"}
              </SpanProductDetail>

              {/* size */}
              <SpanProductDetail center>
                {option?.size?.quantity === "size"
                  ? `${option?.size?.width} ${
                      getLocale() === "th"
                        ? option?.size?.unit_width?.unit_th
                        : option?.size?.unit_width?.unit_en
                    } x ${option?.size?.height} ${
                      getLocale() === "th"
                        ? option?.size?.unit_height?.unit_th
                        : option?.size?.unit_height?.unit_en
                    } x ${option?.size?.thickness} ${
                      getLocale() === "th"
                        ? option?.size?.unit_thickness?.unit_th
                        : option?.size?.unit_thickness?.unit_en
                    }`
                  : option?.size?.quantity === "capacity"
                    ? `${option?.size?.capacity_size} ${
                        getLocale() === "th"
                          ? option?.size?.unit_capacity?.unit_th
                          : option?.size?.unit_capacity?.unit_en
                      }`
                    : getLocale() === "th"
                      ? "สินค้าสั่งทำพิเศษ"
                      : "Made by order"}
              </SpanProductDetail>

              {/* item_code */}
              <SpanProductDetail>
                {option?.product?.item_code ? option?.product?.item_code : "-"}
              </SpanProductDetail>

              {/* choice name */}
              <SpanProductDetail center>
                {option?.name !== "" ? `( ${option?.name} )` : `-`}
              </SpanProductDetail>

              {/* price */}
              <SpanProductDetail price>
                {convertPrice(
                  option?.group_price?.is_start_price === true
                    ? option?.group_price?.start_price
                    : option?.group_price.special_price > 0 &&
                        option?.group_price.special_price !== null &&
                        option?.group_price.special_price !== undefined
                      ? option?.group_price.special_price
                      : option?.group_price?.price,
                )}
                {/* {getLocale() === "th"
                            ? ` บาท / ` +
                              option?.group_price
                                ?.unit_price?.unit_th
                            : ` baht / ` +
                              option?.group_price
                                ?.unit_price?.unit_en} */}
              </SpanProductDetail>
            </ProductChoiceDetail>
          </li>
        )}
        options={productList}
        limitTags={2}
        value={formData?.product_choice_blogs}
        onChange={(event, newValue) => {
          if (
            formData?.product_choice_blogs.length > 1 &&
            newValue.length === 0
          ) {
            openDialog({
              type: "confirm",
              title: "คุณต้องการลบสินค้าทั้งหมดใช่หรือไม่?",
              onConfirm: () => {
                onChange(null, "product_choice_blogs", newValue);
                closeDialog();
              },
              maxWidth: 342,
            });
          } else {
            onChange(null, "product_choice_blogs", newValue);
          }
        }}
        getOptionLabel={(option) => {
          return (
            option?.product?.item_code +
            " - " +
            option?.product?.item_name +
            (option.name !== "" ? ` - (` + option.name + `)` : ``)
          );
        }}
        filterOptions={createFilterOptions({
          matchFrom: "any",
          limit: 100,
        })}
        sx={{
          mt: 2,
          mb: 3,
          width: "100%",
          background: "#fff",
          borderRadius: "16px",
        }}
        renderInput={(params) => (
          <TextField
            className="TextField-without-border-radius"
            {...params}
            label="เลือกสินค้า"
          />
        )}
      />
      <AnimatePresence>
        {formData.contents.map((element, elementIndex) => {
          const contentType = element.group_media.some((item) => item.media)
            ? "media"
            : "link";
          return (
            <S.ContentElement
              id={`content-${elementIndex}`}
              key={`element-` + elementIndex}
              transition={{ type: "spring", bounce: 0.25, duration: 0.2 }}
              layout
            >
              {/* {elementIndex !== 0 && ( */}
              <S.ParagraphBreak $elementIndex={elementIndex}>
                <Stack
                  flexDirection="row"
                  sx={{
                    position: "absolute",
                    top: -20,
                    right: -40,
                    backgroundColor: "#ffffff",
                  }}
                >
                  <IconButton
                    onClick={() =>
                      onReArrangeParagraph(elementIndex, elementIndex - 1)
                    }
                    disabled={elementIndex === 0}
                  >
                    <VerticalAlignTopIcon />
                  </IconButton>
                  <IconButton
                    onClick={() =>
                      onReArrangeParagraph(elementIndex, elementIndex + 1)
                    }
                    disabled={elementIndex === formData.contents.length - 1}
                  >
                    <VerticalAlignBottomIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      if (
                        element.group_media.every(
                          (item) => !!item.media || !!item.link,
                        ) ||
                        !!element.content_text
                      ) {
                        openDialog({
                          type: "confirm",
                          title: "คุณต้องการลบย่อหน้าใช่หรือไม่?",
                          onConfirm: () => {
                            onRemoveElement(elementIndex);
                            closeDialog();
                          },
                          maxWidth: 342,
                        });
                      } else {
                        onRemoveElement(elementIndex);
                      }
                    }}
                    disabled={formData.contents.length === 1}
                  >
                    <CloseIcon />
                  </IconButton>
                </Stack>
              </S.ParagraphBreak>
              {/* )} */}
              <HotspotLayout layout={element?.placement}>
                {
                  // eslint-disable-next-line array-callback-return
                  element.group_media.map((item, mediaIndex) => {
                    if (!item.media && !item.link) {
                      return (
                        <S.MediaUploadBox
                          key={`uploadbox-` + mediaIndex}
                          aspectRatio={
                            element?.placement?.includes("square") ? 1 : 21 / 9
                          }
                        >
                          <S.UploadInnerBox>
                            <Stack flexDirection={"row"} columnGap={6}>
                              <input
                                id={`contents.${elementIndex}.group_media.${mediaIndex}`}
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  e.preventDefault();
                                  onChange(
                                    null,
                                    `contents.${elementIndex}.group_media.${mediaIndex}.media`,
                                    e.target.files[0],
                                  );
                                }}
                                onClick={(e) => {
                                  e.currentTarget.value = null;
                                }}
                              />
                              <S.UploadInput
                                htmlFor={`contents.${elementIndex}.group_media.${mediaIndex}`}
                              >
                                <CameraIcon size={60} color="#BCBCC0" />
                                <S.UploadLabel>อัพโหลดภาพเนื้อหา</S.UploadLabel>
                                <S.UploadHelperText>
                                  รูปภาพขนาด 800 X 800 Pixel <br />{" "}
                                  ขนาดไฟล์สูงสุดไม่เกิน 2 MB
                                </S.UploadHelperText>
                              </S.UploadInput>

                              {contentType !== "media" && (
                                <S.UploadInput
                                  onClick={() => {
                                    openDialog({
                                      type: "custom",
                                      customDialog: (
                                        <AddEmbedModal
                                          onClose={() => closeDialog()}
                                          onSubmit={(val) => {
                                            onChange(
                                              null,
                                              `contents.${elementIndex}.group_media.${mediaIndex}.link`,
                                              val,
                                            );
                                            closeDialog();
                                          }}
                                        />
                                      ),
                                    });
                                  }}
                                >
                                  <PlayerIcon size={64} color="#BCBCC0" />
                                  <S.UploadLabel>
                                    แนบลิงค์วิดีโอเนื้อหา
                                  </S.UploadLabel>
                                  <S.UploadHelperText>
                                    รองรับการแสดงผลวิดีโอจาก <br />
                                    Youtube, Tiktok
                                  </S.UploadHelperText>
                                </S.UploadInput>
                              )}
                            </Stack>
                          </S.UploadInnerBox>
                        </S.MediaUploadBox>
                      );
                    } else if (item.media) {
                      return (
                        <S.MediaUploaded key={`media-` + mediaIndex}>
                          <SpottableImage
                            formControl={formControl}
                            aspectRatio={
                              element?.placement?.includes("square")
                                ? 1
                                : 21 / 9
                            }
                            previewImage={
                              typeof item.media === "string"
                                ? item.media
                                : URL.createObjectURL(item.media)
                            }
                            hotspot={item.hotspot}
                            hotspotArrayKey={`contents.${elementIndex}.group_media.${mediaIndex}.hotspot`}
                            mode={"edit"}
                            productOptions={formData.product_choice_blogs}
                            onSelectProduct={(value, spotIndex) => {
                              onChange(
                                null,
                                `contents.${elementIndex}.group_media.${mediaIndex}.hotspot.${spotIndex}`,
                                value,
                              );
                            }}
                          />
                          <Stack
                            sx={{
                              position: "absolute",
                              top: 6,
                              right: 6,
                              //   backgroundColor: "rgb(255 255 255 / 25%)",
                            }}
                            flexDirection={"row"}
                            columnGap={1}
                          >
                            <IconButton
                              sx={{
                                padding: "4px",
                                backgroundColor: "#BCBCC0bd",
                              }}
                              onClick={() => {
                                openDialog({
                                  type: "custom",
                                  customDialog: (
                                    <ImageCropperModal
                                      aspectRatio={
                                        element?.placement?.includes("square")
                                          ? 1
                                          : 21 / 9
                                      }
                                      imageData={item.media}
                                      onClose={() => {
                                        closeDialog();
                                      }}
                                      onSubmit={(val) => {
                                        onChange(
                                          null,
                                          `contents.${elementIndex}.group_media.${mediaIndex}.media`,
                                          val,
                                        );
                                        closeDialog();
                                      }}
                                    />
                                  ),
                                });
                              }}
                            >
                              <CropIcon sx={{ color: "#ffffff" }} />
                            </IconButton>
                            <IconButton
                              sx={{
                                padding: "4px",
                                backgroundColor: "#BCBCC0bd",
                              }}
                              onClick={() => {
                                onChange(
                                  null,
                                  `contents.${elementIndex}.group_media.${mediaIndex}`,
                                  null,
                                );
                              }}
                            >
                              <CloseIcon sx={{ color: "#ffffff" }} />
                            </IconButton>
                          </Stack>
                        </S.MediaUploaded>
                      );
                    } else if (item.link) {
                      const source = element.group_media[0].link.includes(
                        "tiktok",
                      )
                        ? "tiktok"
                        : "youtube";

                      if (source === "tiktok") {
                        return (
                          <S.MediaUploaded>
                            <S.TikTokEmbed
                              src={element.group_media[0].link}
                              allowfullscreen
                              allow="encrypted-media;"
                            />
                            <IconButton
                              sx={{
                                position: "absolute",
                                top: -20,
                                right: -40,
                                //   backgroundColor: "rgb(255 255 255 / 25%)",
                              }}
                              onClick={() => {
                                onChange(
                                  null,
                                  `contents.${elementIndex}.group_media.${mediaIndex}`,
                                  null,
                                );
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          </S.MediaUploaded>
                        );
                      } else if (source === "youtube") {
                        return (
                          <S.MediaUploaded>
                            <S.VideoEmbedContainer>
                              <S.YoutubeEmbed
                                src={element.group_media[0].link}
                                title="YouTube Video Player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen
                              />
                            </S.VideoEmbedContainer>
                            <IconButton
                              sx={{
                                position: "absolute",
                                top: -20,
                                right: -40,
                                //   backgroundColor: "rgb(255 255 255 / 25%)",
                              }}
                              onClick={() => {
                                onChange(
                                  null,
                                  `contents.${elementIndex}.group_media.${mediaIndex}`,
                                  null,
                                );
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          </S.MediaUploaded>
                        );
                      }
                    }
                  })
                }
              </HotspotLayout>
              {contentType === "media" && (
                <Stack
                  flexDirection={"row"}
                  justifyContent={"space-evenly"}
                  columnGap={1}
                  sx={{ mb: 3 }}
                >
                  <Placement
                    active={element?.placement === "1-square"}
                    repeat={1}
                    width={80}
                    height={80}
                    helperText={"800 x 800"}
                    onClick={() => {
                      onChange(
                        null,
                        `contents.${elementIndex}.placement`,
                        "1-square",
                      );
                    }}
                  />
                  <Placement
                    active={element?.placement === "2-square"}
                    repeat={2}
                    width={80}
                    height={80}
                    helperText={"800 x 800"}
                    onClick={() => {
                      onChange(
                        null,
                        `contents.${elementIndex}.placement`,
                        "2-square",
                      );
                    }}
                  />
                  <Placement
                    active={element?.placement === "1-landscape"}
                    repeat={1}
                    width={190}
                    height={80}
                    helperText={"800 x 342"}
                    onClick={() => {
                      onChange(
                        null,
                        `contents.${elementIndex}.placement`,
                        "1-landscape",
                      );
                    }}
                  />
                </Stack>
              )}
              <TextEditor
                name={`contents.${elementIndex}.content_text`}
                value={element?.content_text}
                onChange={(data) => {
                  onChange(null, `contents.${elementIndex}.content_text`, data);
                }}
                editorLoaded={editorLoaded}
              />
              {formErrors[`contents[${elementIndex}].content_text`] && (
                <FormHelperText
                  error={!!formErrors[`contents[${elementIndex}].content_text`]}
                >
                  กรุณากรอกเนื้อหาบทความ
                </FormHelperText>
              )}
              <Button
                variant="text"
                size="large"
                startIcon={<AddIcon />}
                onClick={() => onAppendElement(elementIndex + 1)}
                // disabled={formData.cosntents.length === MAX_CONTENT_PARAGRAPH}
                sx={{
                  alignSelf: "flex-start",
                  marginTop: 2,
                }}
              >
                เพิ่มเนื้อหาบทความ
              </Button>
            </S.ContentElement>
          );
        })}
      </AnimatePresence>
    </S.Container>
  );
};

export default Step2;
